import createSvgIcon from '@mui/icons-material/utils/createSvgIcon'
import React from 'react'
// viewBox="0 0 32 32"

const ArrowUpIcon = createSvgIcon(
  <>
    <path d='M16.1 7.875l12.7 12.7L25.35 24l-9.4-9.425-9.475 9.475-3.3-3.3 4.9-4.875z' />
  </>,
  'ArrowUpIcon'
)

export default ArrowUpIcon
